import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_FIRE_PANEL_LIST } from './url-constants';

type FirePanelListRequestEndpointSpecifications = ApiEndpointSpecification;
export const FirePanelListRequestEndpointSpecification: FirePanelListRequestEndpointSpecifications = {
    url: GET_FIRE_PANEL_LIST,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'FirePanelListRequestParams',
    requestBodySchemaName: 'FirePanelListRequestBody',
    okResponseSchemaName: 'FirePanelListRequestOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: false,
};

export const invokeFirePanelListRequest = Helpers.makeApiRequestFn<
    Types.FirePanelListRequestParams,
    Types.FirePanelListRequestBody,
    Types.FirePanelListRequestOkResponse
>(FirePanelListRequestEndpointSpecification);
